import { render, staticRenderFns } from "./UntappdFeed.vue?vue&type=template&id=7c16421e&"
import script from "./UntappdFeed.vue?vue&type=script&lang=js&"
export * from "./UntappdFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports